import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CompanyProfileTopBar } from "../../features/CompanyProfile";
import { VendorCompanyTab, VendorLanguageTab, VendorSipHeadersTab } from '../../features/VendorProfile';
import { VendorRoutParam, VendorConnectionType } from "../../models";
import { useFunctionalityVendors } from "../hooks";

export function PageVendorsProfile(): JSX.Element {
  const location = useLocation<VendorRoutParam>();
  const { companyId, vendorName, vendorType } = location?.state;
  const [activeTab, setActiveTab] = useState('company');

  useEffect(() => {
    if (vendorType !== VendorConnectionType.SipUrl && activeTab === 'sip') {
      setActiveTab('company');
    }
  }, [activeTab, vendorType]);

  return (
    <>
      <CompanyProfileTopBar companyName={vendorName} heading="Vendors" />

      <div className="row mt-4">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <div className="profile-tab-container">
                <nav>
                  <div className="nav nav-tabs" id="profile-nav-tab" role="tablist">
                    <button type="button" className={`nav-link ${activeTab === 'company' ? 'active' : ''}`} id="nav-profile-vendor-company-tab" role="tab" aria-controls="nav-profile-vendor-company" aria-selected={activeTab === 'company'} onClick={() => setActiveTab('company')}>Company</button>
                    <button type="button" className={`nav-link ${activeTab === 'language' ? 'active' : ''}`} id="nav-profile-vendor-language-tab" role="tab" aria-controls="nav-profile-vendor-language" aria-selected={activeTab === 'language'} onClick={() => setActiveTab('language')}>Language</button>
                    {vendorType === VendorConnectionType.SipUrl &&
                      <button type="button" className={`nav-link ${activeTab === 'sip' ? 'active' : ''}`} id="nav-profile-vendor-SIP-tab" role="tab" aria-controls="nav-profile-vendor-SIP" aria-selected={activeTab === 'sip'} onClick={() => setActiveTab('sip')}>SIP Headers</button>
                    }
                  </div>
                </nav>
                <div className="tab-content profile-tab-content-container" id="nav-tabContent">
                  <div className={`tab-pane fade show ${activeTab === 'company' ? 'active' : ''}`} id="nav-profile-vendor-company" role="tabpanel" aria-labelledby="nav-profile-vendor-company-tab">
                    <VendorCompanyTab parentCompanyId={companyId} />
                  </div>
                  <div className={`tab-pane fade show ${activeTab === 'language' ? 'active' : ''}`} id="nav-profile-vendor-language" role="tabpanel" aria-labelledby="nav-profile-vendor-language-tab">
                    <VendorLanguageTab />
                  </div>
                  {vendorType === VendorConnectionType.SipUrl &&
                    <div className={`tab-pane fade show ${activeTab === 'sip' ? 'active' : ''}`} id="nav-profile-vendor-SIP" role="tabpanel" aria-labelledby="nav-profile-vendor-SIP-tab">
                      <VendorSipHeadersTab />
                    </div>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
